// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"263501c5","977":"6b3de3d7"}[chunkId] + ".chunk.js";
};